import { TargetAccumulatorPriceButton } from '@/App/tiles/TargetAccumulator/Footer/PriceButton.tsx';
import { TimestampButton } from '@/App/tiles/TargetAccumulator/Footer/TimeStampButton.tsx';
import TargetAccumulatorTraderInfos from '@/App/tiles/TargetAccumulator/Footer/TraderInfos.tsx';

const TargetAccumulatorFooter = ({ tileId }: { tileId: string }) => {
  return (
    <div className="mt-auto px-8px pt-16px pb-8px">
      <TargetAccumulatorPriceButton tileId={tileId} />
      <div className="d-flex flex-between">
        <TimestampButton tileId={tileId} />
        <TargetAccumulatorTraderInfos />
      </div>
    </div>
  );
};

export default TargetAccumulatorFooter;
